import { array, struct } from 'io-ts/Decoder';

import { Id as MaterialTemplateUsageId } from '../../../../../whole-house/material-template/usage/Id';
export const Request = struct({
	materialTemplateUsageIds: array(MaterialTemplateUsageId),
});
